import { Checkbox } from "@mui/material";

type CheckBoxReadOnlyCellProps = {
  value: any;
};

export default function CheckBoxReadOnlyCell(props: CheckBoxReadOnlyCellProps) {
  return <Checkbox checked={props.value} />;
}
